export default __webpack_public_path__ + "static/media/alexanderpool_thumb.58296971.jpg";